import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { agentLoggedOut, companyLoggedOut, getSerialTickets, selectClubOneTab } from '../../actions/actions'
import ButtonBack from '../layout/ButtonBack/ButtonBack'
import Layout from '../layout/Layout'
import CompanyCustomerLogin from './CompanyCustomerLogin/CompanyCustomerLogin'
import s from './CompanyCustomerLoginPage.module.scss'

export default function CompanyCustomerLoginPage() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  return (
    <Layout pageTitle={t('mainPage.title')}>
      <div className={s['company-customer-login-page']}>
        <ButtonBack onClick={handleBackButtonClick} />
        <CompanyCustomerLogin onCancelButtonClick={handleBackButtonClick} onLoginSuccess={handleLoginSuccess} />
      </div>
    </Layout>
  )

  function handleLoginSuccess() {
    dispatch(getSerialTickets())
    history.goBack()
  }

  function handleBackButtonClick() {
    dispatch(selectClubOneTab())
    dispatch(companyLoggedOut())
    dispatch(agentLoggedOut())
    history.goBack()
  }
}
